module.exports = __webpack_public_path__ + "070130ed94ce60f157e0418aaba893f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/features_clock.png
// module id = uD13
// module chunks = 5